import React, { useState } from "react";
import Dropdown from "semantic-ui-react/dist/es/modules/Dropdown";
import { ReactComponent as DownloadIcon } from "../../../../assets/svg/downloads.svg";
import DimmerComponent from "../DimmerComponent";

const DownloadChart = ({ options, nodata }) => {
    const [downloading, setDownloading] = useState(false);

    const download = (o) => {
        if (o.showLoader) setDownloading(true);
        setTimeout(() => {
            if (o.showLoader) o.downloadFn(() => setDownloading(false), o);
            else o.downloadFn();
        }, 0);
    };

    return (
        <>
            <Dropdown
                data-html2canvas-ignore="true"
                disabled={nodata}
                trigger={
                    <div className="chart-header-icon">
                        <DownloadIcon className="chart-download-icon" />
                    </div>
                }
                icon={null}
                className="chart-download-dropdown hideable"
                direction="left">
                <Dropdown.Menu>
                    {options.map((o) => {
                        return (
                            <Dropdown.Item key={o.name} onClick={() => download(o)}>
                                {o.name}
                            </Dropdown.Item>
                        );
                    })}
                </Dropdown.Menu>
            </Dropdown>
            {downloading && <DimmerComponent className="download-dimmer" />}
            {/* <DimmerComponent className="download-dimmer" /> */}
        </>
    );
};

export default DownloadChart;
